// extracted by mini-css-extract-plugin
export default {"logoBox":"_2FvNlVMl","content":"_1JitF6Ks"};